import { useRef } from 'react';
import * as R from 'remeda';
import { Chip, Skeleton, Stack } from '@rossum/ui/material';

export const ChipListSkeleton = () => {
  const skeletons = useRef(
    Array.from({ length: 2 }, () => R.randomInteger(100, 250))
  ).current;

  return (
    <Stack justifyContent="flex-start" direction="row" gap={1}>
      {skeletons.map((width, index) => (
        <Chip
          // oxlint-disable-next-line react/no-array-index-key
          key={`${width}-${index}`}
          label={<Skeleton width={width} />}
        />
      ))}
    </Stack>
  );
};
